import React, { useState, useEffect } from "react";
import { FormattedMessage, FormattedDate, FormattedNumber, FormattedPlural, FormattedTime } from 'react-intl';
import { useForm } from "react-hook-form";
import logo from "../../../../assets/images/fnlogo.jpeg";
import { useDispatch, useSelector } from "react-redux";
import "../otp/otp/otp.scss";
import * as commonService from "utils/CommonService.js";
import storage from "utils/storage";
import classNames from "classnames";
import Alert from "@material-ui/lab/Alert";
import { BsPencil } from "react-icons/bs";
import * as userActions from "redux/actions/UserActions";
import * as authActions from "redux/actions/AuthActions";
import { useIntl } from "react-intl";
import { getSource } from '../../../../utils/CommonService';
import { clearPhoneLogin, hasPhoneLogin, sendPhoneOtp, confirmPhoneOtp, phoneAuthError } from '../../../../utils/phoneAuth';

const RecruiterVerifyOTP = ({ history }) => {
  const [busy, setBusy] = useState(false);
  const [verified, setVerified] = useState(false);
  const [counter, setCounter] = useState(60); // timeout for OTP to 60 seconds
  const userName = storage.get("user_name");
  const loginType = storage.get("login_type"); // "contact" (Firebase) or "email" (legacy backend)
  const dispatch = useDispatch();
  const translate = useIntl();
  const [errorMessage, setErrorMessage] = useState("");
  const { userDetails } = useSelector((state) => state.authReducer);
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });

  /**
   * method to verify otp
   * @param {Object} val values enter by user (OTP)
   *
   */
  const update = async (val) => {
    if (busy || verified) return;
    setBusy(true);
    setErrorMessage('');
    try {
      if (loginType === 'contact') {
        // phone login: Firebase validates the OTP first...
        commonService.isLoading.onNext(true); // show loader while Firebase verifies the OTP
        const idToken = await confirmPhoneOtp(userName, val.otp);
        // ...then the backend independently re-verifies that Firebase ID token
        // (via Firebase Admin) before it trusts the number as verified and logs the user in.
        const res = await dispatch(authActions.verifyOTP({
          user_name: `${userName}`,
          login_type: 'contact',
          firebase_id_token: idToken,
          lead_source: getSource(),
        }));
        if (res.value.success) {
          clearPhoneLogin();
          setVerified(true);
          storage.set("profile_status", res.value.data.profile_status);
          commonService.forSuccess(res.value.message, "Success");
          if (res.value.data.profile_status) {
            history.push("/dashboard");
          } else {
            history.push("/companydetail");
          }
        }
      } else {
        // email login keeps the legacy backend-verified flow
        const loginSource = getSource(); // getting source from where user comes
        let data = {
          ...val,
          login_type: loginType,
          user_name: userName,
          lead_source: loginSource
        };
        const res = await dispatch(authActions.verifyOTP(data));
        if (res.value.success) {
          // set value of profile status in storage
          storage.set("profile_status", res.value.data.profile_status);
          if (res.value.data.profile_status) {
            history.push("/dashboard");
          } else {
            history.push("/companydetail");
          }
          commonService.forSuccess(res.value.message, "Success");
        }
      }
    } catch (err) {
      // err.data means the backend rejected the request (e.g. token verification failed);
      // anything else, for a phone login, is a Firebase-side error (wrong code, expired session, etc.)
      setErrorMessage(err.data ? (err.data.message || 'Unable to verify OTP. Please try again.') : (loginType === 'contact' ? phoneAuthError(err) : 'Unable to verify OTP. Please try again.'));
    } finally {
      setBusy(false);
      if (loginType === 'contact') commonService.isLoading.onNext(false);
    }
  };

  useEffect(() => {
    // only phone logins depend on a pending Firebase session; email logins keep the legacy flow
    if (loginType === 'contact' && !hasPhoneLogin(userName)) {
      history.replace({ pathname: '/recruiter', state: history.location.state });
    }
  }, [history, userName, loginType]);

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const resendOtp = async () => {
    if (busy || counter > 0 || verified) return;
    setErrorMessage('');
    if (loginType === 'contact') {
      setBusy(true);
      commonService.isLoading.onNext(true); // show loader while Firebase resends the OTP
      try {
        await sendPhoneOtp(userName, 'firebase-resend-recaptcha');
        setCounter(60);
      } catch (err) {
        setErrorMessage(phoneAuthError(err));
      } finally {
        setBusy(false);
        commonService.isLoading.onNext(false);
      }
    } else {
      let data = { user_name: userName, login_type: loginType };
      dispatch(authActions.getRecruiterOTP(data))
        .then((res) => {
          if (res.value.success) {
          }
        })
        .catch((err) => console.log(err));
      // set counter to 60 sec after requesting otp
      setCounter(60);
    }
  };
  return (
    <>
      <div className="top_main">
        <div id="firebase-resend-recaptcha" />
        <div className="verify_otp_main">
          <div className="row no-gutters">
            <div className="col-md-4"></div>
            <div className="col-md-4 otp_rb sha p-4">
              <div className="px-3 px-lg-5 pt-3">
                <div className="d-flex justify-content-center">
                  <img src={logo} width="200px" alt="logo" className="mx-auto" />
                </div>
                <p className="otp_ver text-center mt-3 mb-3 font-bold">
                  {" "}
                  <FormattedMessage
                    id="otpVerification"
                    defaultMessage="OTP Verfication"
                  />
                </p>
                <div>
                  <form onSubmit={handleSubmit(update)}>
                    <div className="login_details">
                      <div className="otp_b text-bold p-0 m-0 mb-1 text-center ">
                        <p >
                          {" "}
                          {loginType === 'email' ? (
                            <FormattedMessage
                              id="enterOtpEmail"
                              defaultMessage="Enter OTP sent to {number}"
                              values={{ number: userName }}
                            />
                          ) : (
                            <FormattedMessage
                              id="enterOtp"
                              defaultMessage="Enter OTP sent to +91 {number}"
                              values={{ number: userName }}
                            />
                          )}
                          <BsPencil
                            className="pencil"
                            onClick={history.goBack}
                            style={{ float: 'right' }}
                          />
                        </p>
                      </div>
                      <input
                        name="otp"
                        autoComplete="one-time-code"
                        inputMode="numeric"
                        maxLength={loginType === 'contact' ? 6 : 4}
                        disabled={busy || verified}
                        className={classNames("form-control", {
                          "is-invalid": errors.otp,
                        })}
                        ref={register(loginType === 'contact' ? {
                          required: translate.formatMessage({
                            id: "mustEnterOtp",
                          }),
                          pattern: {
                            value: /^\d{6}$/,
                            message: 'Please enter the six-digit OTP.',
                          },
                        } : {
                          required: translate.formatMessage({
                            id: "mustEnterOtp",
                          }),
                          minLength: {
                            value: 4,
                            message: translate.formatMessage({
                              id: "otpLength",
                            }),
                          },
                          maxLength: {
                            value: 4,
                            message: translate.formatMessage({
                              id: "mustFourDigit",
                            }),
                          },
                        })
                        }
                      />
                      {errors.otp && (
                        <p className="text-danger tnc_alrt ">
                          {errors.otp.message}
                        </p>
                      )}
                      <div>{counter ?
                        (<div className="mt-2 d-flex justify-content-center mb-3 mt-2text-capitalize">
                          {" "}
                          <p className="text-center" ><FormattedMessage id="resendOtpIn" /> <span className="text-success">{counter} </span> secs </p>{" "}
                        </div>
                        ) :
                        (<div className="mt-2 d-flex justify-content-center mb-3 mt-2text-capitalize">
                          <FormattedMessage id="notReceiveOtp" />
                          <button type="button" disabled={busy || verified} className="btn btn-link text-decoration-none ml-1 cursor_otp" onClick={resendOtp}>
                            <FormattedMessage id="resendOtp" />
                          </button>{" "}
                        </div>)
                      }
                      </div>
                      <button className="common_btn login_btn" type="submit" disabled={busy || verified}>
                        <FormattedMessage id="verifyAndProceed" />
                      </button>
                    </div>
                  </form>
                  <div className="mt-3">
                    {verified && <Alert severity="success">Mobile number verified successfully.</Alert>}
                    {errorMessage && errorMessage.length > 0 && (
                      <Alert severity="error">{errorMessage} !</Alert>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default RecruiterVerifyOTP;
